import { createContext, useContext, useState } from "react";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  });

  const signin = (t, u) => {
    setToken(t);
    setUser(u);
    localStorage.setItem("token", t);
    // console.log("USERS CREDENTIAL", JSON.stringify(u));

    localStorage.setItem("user", JSON.stringify(u));
    // for multi-tenant backends:
    if (!localStorage.getItem("tenant")) localStorage.setItem("tenant", "demo");
  };

  const signout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };

  return (
    <Ctx.Provider value={{ token, user, signin, signout }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
